module.exports = __webpack_public_path__ + "static/media/library-smart.d3ea7f09.svg";